import {
    USER_DATA, USER_TOKENS_DETAILS,
    SELECTED_FILTER_VALUE, SELECTED_SORT_VALUE,
    SELECTED_FILTER_ID, PAGE_SIZE_ON_NAVIGATION,
    SCROLL_OFFSET, CART_COUNT, CART_AMOUNT, CART_ID, LOGOUT_USER, APP_BANNER,
    ACF, ALL_CATEGORIES, ALL_SPECIAL_CATEGORIES, ALL_MERCHANTS, TILES
} from './types'
export const addUserData = (data) => {
    return {
        type: USER_DATA,
        payLoad: data
    }
}
export const addUserTokenDetails = (data) => {
    return {
        type: USER_TOKENS_DETAILS,
        payLoad: data
    }
}
// export const deletePost = (id) => {
//     return {
//         type: 'DELETE_POST',
//         payLoad: id
//     }
// }


export const addSelectedFilterValue = (data) => {
    return {
        type: SELECTED_FILTER_VALUE,
        payLoad: data
    }
}

export const addSelectedSortValue = (data) => {
    return {
        type: SELECTED_SORT_VALUE,
        payLoad: data
    }
}

export const addSelectedFilterID = (data) => {
    return {
        type: SELECTED_FILTER_ID,
        payLoad: data
    }
}

export const addPageSize = (data) => {
    return {
        type: PAGE_SIZE_ON_NAVIGATION,
        payLoad: data
    }
}
export const addScrollOffset = (data) => {
    return {
        type: SCROLL_OFFSET,
        payLoad: data
    }
}
export const UpdateCartCount = (data) => {
    return {
        type: CART_COUNT,
        payLoad: data
    }
}
export const UpdateCartAmount = (data) => {
    return {
        type: CART_AMOUNT,
        payLoad: data
    }
}
export const UpdateCartID = (data) => {
    return {
        type: CART_ID,
        payLoad: data
    }
}
export const setAppBanner = (data) => {
    return {
        type: APP_BANNER,
        payLoad: data
    }
}
export const userLogout = () => {
    return {
        type: LOGOUT_USER
    }
}
export const setACF = (data) => {
    return {
        type: ACF,
        payLoad: data
    }
}
export const setAllCategories = (data) => {
    return {
        type: ALL_CATEGORIES,
        payLoad: data
    }
}
export const setAllSpecialCategories = (data) => {
    return {
        type: ALL_SPECIAL_CATEGORIES,
        payLoad: data
    }
}
export const setAllMerchants = (data) => {
    return {
        type: ALL_MERCHANTS,
        payLoad: data
    }
}
export const setTiles = (data) => {
    return {
        type: TILES,
        payLoad: data
    }
}
